/**
 * API base URL for backend. Set REACT_APP_API_URL in .env (or hosting env) when deploying.
 * Development: defaults to http://localhost:5000
 */
export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';
